import { render, staticRenderFns } from "./admin-layout.vue?vue&type=template&id=528fa74c&scoped=true&"
import script from "./admin-layout.vue?vue&type=script&lang=js&"
export * from "./admin-layout.vue?vue&type=script&lang=js&"
import style0 from "./admin-layout.vue?vue&type=style&index=0&id=528fa74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528fa74c",
  null
  
)

export default component.exports